// Fetch (published) news items
// TODO: fix limit: number = 10, it breaks something
export function fetchNews(pageType: PageType = PageType.News) {
  return fetchPages({
    'scope': 'public',
    'filter[page_type_eq]': pageType,
    'sort': '-created_at',
    // 'limit': limit,
  })
}
